import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import PublicTracking from "@/pages/PublicTracking";
import Perfil from "@/pages/Perfil";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AdminClientes, AdminRepartidores } from "@/pages/admin/AdminUsers";
import AdminPedidos from "@/pages/admin/AdminPedidos";
import AdminBodega from "@/pages/admin/AdminBodega";
import AdminGeocache from "@/pages/admin/AdminGeocache";
import AdminReportes from "@/pages/admin/AdminReportes";
import AdminConfig from "@/pages/admin/AdminConfig";
import AdminLeads from "@/pages/admin/AdminLeads";

import ClienteDashboard from "@/pages/cliente/ClienteDashboard";
import ClientePedidos from "@/pages/cliente/ClientePedidos";
import NuevoPedido from "@/pages/cliente/NuevoPedido";
import CargaMasiva from "@/pages/cliente/CargaMasiva";
import ClienteBultos from "@/pages/cliente/ClienteBultos";
import ClienteReportes from "@/pages/cliente/ClienteReportes";

import RepartidorHome from "@/pages/repartidor/RepartidorHome";
import LoteRetiro from "@/pages/repartidor/LoteRetiro";
import RutaReparto from "@/pages/repartidor/RutaReparto";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={`/${user.role}`} replace />;
  return <Landing />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#18181b", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/rastreo" element={<PublicTracking />} />
          <Route path="/rastreo/:tn" element={<PublicTracking />} />
          <Route path="/perfil" element={<ProtectedRoute roles={["admin", "cliente", "repartidor"]}><Perfil /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/pedidos" element={<ProtectedRoute roles={["admin"]}><AdminPedidos /></ProtectedRoute>} />
          <Route path="/admin/bodega" element={<ProtectedRoute roles={["admin"]}><AdminBodega /></ProtectedRoute>} />
          <Route path="/admin/clientes" element={<ProtectedRoute roles={["admin"]}><AdminClientes /></ProtectedRoute>} />
          <Route path="/admin/repartidores" element={<ProtectedRoute roles={["admin"]}><AdminRepartidores /></ProtectedRoute>} />
          <Route path="/admin/geocache" element={<ProtectedRoute roles={["admin"]}><AdminGeocache /></ProtectedRoute>} />
          <Route path="/admin/reportes" element={<ProtectedRoute roles={["admin"]}><AdminReportes /></ProtectedRoute>} />
          <Route path="/admin/config" element={<ProtectedRoute roles={["admin"]}><AdminConfig /></ProtectedRoute>} />
          <Route path="/admin/leads" element={<ProtectedRoute roles={["admin"]}><AdminLeads /></ProtectedRoute>} />

          {/* Cliente */}
          <Route path="/cliente" element={<ProtectedRoute roles={["cliente"]}><ClienteDashboard /></ProtectedRoute>} />
          <Route path="/cliente/pedidos" element={<ProtectedRoute roles={["cliente"]}><ClientePedidos /></ProtectedRoute>} />
          <Route path="/cliente/nuevo" element={<ProtectedRoute roles={["cliente"]}><NuevoPedido /></ProtectedRoute>} />
          <Route path="/cliente/masivo" element={<ProtectedRoute roles={["cliente"]}><CargaMasiva /></ProtectedRoute>} />
          <Route path="/cliente/bultos" element={<ProtectedRoute roles={["cliente"]}><ClienteBultos /></ProtectedRoute>} />
          <Route path="/cliente/reportes" element={<ProtectedRoute roles={["cliente"]}><ClienteReportes /></ProtectedRoute>} />

          {/* Repartidor */}
          <Route path="/repartidor" element={<ProtectedRoute roles={["repartidor"]}><RepartidorHome /></ProtectedRoute>} />
          <Route path="/repartidor/lote/:id" element={<ProtectedRoute roles={["repartidor"]}><LoteRetiro /></ProtectedRoute>} />
          <Route path="/repartidor/ruta" element={<ProtectedRoute roles={["repartidor"]}><RutaReparto /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
